export const ProductTabType = Object.freeze({
  DOWNLOAD: "DOWNLOAD",
  TECHNICAL: "TECHNICAL",
  SOFTWARE: "SOFTWARE",
  TRAINING: "TRAINING",
  SQUARE: "SQUARE",
  SAMPLE_STORE: "SAMPLE_STORE",
  SW_SERVICE: "SW_SERVICE"
});

export const getDocTypeLangKey = (value: string) => {
  switch (value) {
    case ProductTabType.DOWNLOAD:
      return 'I18N_TAB_DOWNLOAD';
    case ProductTabType.TECHNICAL:
      return 'I18N_TAB_TECHNICAL';
    case ProductTabType.SOFTWARE:
      return 'I18N_TAB_SOFTWARE';
    case ProductTabType.TRAINING:
      return 'I18N_TAB_TRAINING';
    case ProductTabType.SQUARE:
      return 'I18N_TAB_SQUARE';
    case ProductTabType.SAMPLE_STORE:
      return 'I18N_TAB_SAMPLE';
    case ProductTabType.SW_SERVICE:
      return 'I18N_TAB_SW_SERVICE';
    default:
      return '';
  }
};
